import { createContext } from 'react';
export const BottomSheetModalContext = /*#__PURE__*/createContext(null);
export const BottomSheetModalProvider = BottomSheetModalContext.Provider;
//# sourceMappingURL=external.js.map